<template>
  <div :data-name="name" v-show="isActive">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: false,
    };
  },

  props: {
    name: {
      type: String,
      required: true,
    },

    selected: {
      type: Boolean,
      required: false,
      default: false,
    },

    tabClass: {
      type: String,
      required: false,
    },
  },

  computed: {
    href() {
      return `#${this.toLowercase(this.name)}`;
    },
  },

  methods: {
    toLowercase(str) {
      return str.toLowerCase().replace(/ /g, '-');
    },
  },

  mounted() {
    this.isActive = this.selected;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/products/partials/LanguageTab.vue